export default __webpack_public_path__ + "static/media/Spiritual-Gifts-Dove.932dde39.svg";